// insert tooltip texts into tooltip Dictionary
    export const expenseCategoryTooltipsDictionary = [
    "Gasoline": "This is a vehicle related expense included in the Standard Mileage Rate. Keep track to compare against the Actual Expense Method at the end of the year.",
    "Car Maintenance and Repairs": "This is a vehicle related expense included in the Standard Mileage Rate. Keep track to compare against the Actual Expense Method at the end of the year.",
    "Car Lease Payments": "This is a vehicle related expense included in the Standard Mileage Rate. Keep track to compare against the Actual Expense Method at the end of the year.",
    "Parking Fees and Tolls": "These are deductible even if you are using the Standard Mileage Rate.",
    "In Car Entertainment": "This is a vehicle related expense included in the Standard Mileage Rate. Keep track to compare against the Actual Expense Method at the end of the year.",
    "Car Wash / Cleaning": "This is a vehicle related expense included in the Standard Mileage Rate. Keep track to compare against the Actual Expense Method at the end of the year.",
    "Garage Rent": "This is a vehicle related expense included in the Standard Mileage Rate. Keep track to compare against the Actual Expense Method at the end of the year.",
    "Snacks & Drinks for Clients (50%)": "This includes things like water, candy, and other amenities for your clients. Unfortunately you cannot expense personal meals such as lunch by yourself.",
    "Other Vehicle Related Expenses": "This is a vehicle related expense included in the Standard Mileage Rate. Keep track to compare against the Actual Expense Method at the end of the year.",
    "Car Insurance": "This is a vehicle related expense included in the Standard Mileage Rate. Keep track to compare against the Actual Expense Method at the end of the year.",
    "Mobile Phone Plan": "Business portion only",
    "Electronics (Phone, Laptop, etc.)": "Business portion only",
    "Software": "Business portion only",
    "Tools": "Business portion only",
    "Business Travel": "Flights, hotels, etc.",
    "Reimbursement": nil,
    "Office Expenses": "Business portion only",
    "Advertising and Marketing": nil,
    "Legal / Professional Services": nil,
    "Professional Dues and Fees": nil,
    "Postage, Packaging, and Shipping": nil,
    "Business Gifts (Up to $25)": nil,
    "Business Meals & Entertainment": "This is 50% of a business related meal. You cannot expense personal meals such as lunch by yourself.",
    "Referral and Commission Fees": nil,
    "Retirement Plan Contributions": nil,
    "Professional Journal Subscriptions": nil,
    "Real Estate Franchise Fees": nil,
    "Cleaning": nil,
    "Non-vehicle Related Insurance": nil,
    "Loan Interest (Small business, etc.)": nil,
    "Inventory": nil,
    "Supplies": nil,
    "Home Office Deductions": nil,
    "Depreciation and Section 179": "If this is a vehicle related depreciation expense, it is already reflected in the Standard Mileage Rate and cannot be claimed here.",
    "Education and Training": nil,
    "Other Business Expenses": nil,
    "Charitable Donation": nil
    ]

    export const defaultExpenseCategories = [
    "Gasoline",
    "Car Maintenance and Repairs",
    "Car Lease Payments",
    "Parking Fees and Tolls",
    "In Car Entertainment",
    "Car Wash / Cleaning",
    "Garage Rent",
    "Snacks & Drinks for Clients (50%)",
    "Other Vehicle Related Expenses",
    "Car Insurance",
    "Mobile Phone Plan",
    "Electronics (Phone, Laptop, etc.)",
    "Software",
    "Tools",
    "Business Travel",
    "Reimbursement",
    "Office Expenses",
    "Advertising and Marketing",
    "Legal / Professional Services",
    "Professional Dues and Fees",
    "Postage, Packaging, and Shipping",
    "Business Gifts (Up to $25)",
    "Business Meals & Entertainment",
    "Referral and Commission Fees",
    "Retirement Plan Contributions",
    "Professional Journal Subscriptions",
    "Real Estate Franchise Fees",
    "Cleaning",
    "Non-vehicle Related Insurance",
    "Loan Interest (Small business, etc.)",
    "Inventory",
    "Supplies",
    "Home Office Deductions",
    "Depreciation and Section 179",
    "Education and Training",
    "Other Business Expenses",
    "Charitable Donation"
    ]

    export const uberExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "In Car Entertainment",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Snacks & Drinks for Clients (50%)",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Reimbursement",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Retirement Plan Contributions",
        "Non-vehicle Related Insurance",
        "Supplies",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]

    export const lyftExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "In Car Entertainment",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Snacks & Drinks for Clients (50%)",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Reimbursement",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Retirement Plan Contributions",
        "Non-vehicle Related Insurance",
        "Supplies",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]
    export const taskrabbitExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Reimbursement",
        "Tools",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Retirement Plan Contributions",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]
    export const doordashExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Reimbursement",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Retirement Plan Contributions",
        "Non-vehicle Related Insurance",
        "Supplies",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]
    export const instacartExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Reimbursement",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Retirement Plan Contributions",
        "Non-vehicle Related Insurance",
        "Supplies",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]
    export const airbnbExpenseCategories = [
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses"
    ]

    export const postmatesExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Reimbursement",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Retirement Plan Contributions",
        "Non-vehicle Related Insurance",
        "Supplies",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]

    export const realEstateExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Snacks & Drinks for Clients (50%)",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Tools",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Real Estate Franchise Fees",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]
    export const creativeExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Snacks & Drinks for Clients (50%)",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Tools",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Inventory",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]
    export const photographyExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Snacks & Drinks for Clients (50%)",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Tools",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Inventory",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]
    export const foodservicesExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Snacks & Drinks for Clients (50%)",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Tools",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Inventory",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]
    export const coachingExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Snacks & Drinks for Clients (50%)",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Tools",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]
    export const tutoringExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Snacks & Drinks for Clients (50%)",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Tools",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]
    export const truckingExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Tools",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]

    export const religiousServicesExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Tools",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Education and Training",
        "Other Business Expenses",
        "Charitable Donation"
    ]

    export const insuranceExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "In Car Entertainment",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Snacks & Drinks for Clients (50%)",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Tools",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Inventory",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Other Business Expenses",
        "Charitable Donation"
    ]

    export const physicianExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "In Car Entertainment",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Snacks & Drinks for Clients (50%)",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Tools",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Inventory",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Other Business Expenses",
        "Charitable Donation"
    ]

    export const consultantExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "In Car Entertainment",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Snacks & Drinks for Clients (50%)",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Tools",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Inventory",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Other Business Expenses",
        "Charitable Donation"
    ]

    export const legalExpenseCategories = [
        "Gasoline",
        "Car Maintenance and Repairs",
        "Car Lease Payments",
        "Parking Fees and Tolls",
        "In Car Entertainment",
        "Car Wash / Cleaning",
        "Garage Rent",
        "Snacks & Drinks for Clients (50%)",
        "Other Vehicle Related Expenses",
        "Car Insurance",
        "Mobile Phone Plan",
        "Electronics (Phone, Laptop, etc.)",
        "Software",
        "Tools",
        "Business Travel",
        "Reimbursement",
        "Office Expenses",
        "Advertising and Marketing",
        "Legal / Professional Services",
        "Professional Dues and Fees",
        "Postage, Packaging, and Shipping",
        "Business Gifts (Up to $25)",
        "Business Meals & Entertainment",
        "Referral and Commission Fees",
        "Retirement Plan Contributions",
        "Professional Journal Subscriptions",
        "Cleaning",
        "Non-vehicle Related Insurance",
        "Loan Interest (Small business, etc.)",
        "Inventory",
        "Supplies",
        "Home Office Deductions",
        "Depreciation and Section 179",
        "Other Business Expenses",
        "Charitable Donation"
    ]

    export const expenseImagesDictionary = [
        "Gasoline": "Gas-100",
        "Car Maintenance and Repairs": "Maintenance-100",
        "Car Lease Payments": "Car_Lease-100",
        "Parking Fees and Tolls": "Parking-100",
        "In Car Entertainment": "Entertainment-100",
        "Car Wash / Cleaning": "Car_Wash-100",
        "Garage Rent": "Garage-100",
        "Snacks & Drinks for Clients (50%)": "Food-100",
        "Other Vehicle Related Expenses": "Vehicle_Expenses-100",
        "Car Insurance": "Car_Insurance-100",
        "Mobile Phone Plan": "Phone-100",
        "Electronics (Phone, Laptop, etc.)": "Electronics-100",
        "Software": "Software-100",
        "Tools": "Tools-100",
        "Business Travel": "Travel-100",
        "Reimbursement": "Reimbursement-100",
        "Office Expenses": "Office_Expenses-100",
        "Advertising and Marketing": "Advertising-100",
        "Legal / Professional Services": "Legal-100",
        "Professional Dues and Fees": "ProfessionalDuesandFees-100",
        "Postage, Packaging, and Shipping": "Postage-100",
        "Business Gifts (Up to $25)": "BusinessGift-100",
        "Business Meals & Entertainment": "BusinessMeals-100",
        "Referral and Commission Fees": "Referral-100",
        "Retirement Plan Contributions": "Retirement-100",
        "Professional Journal Subscriptions": "JournalSubscriptions-100",
        "Real Estate Franchise Fees": "Franchise-100",
        "Cleaning": "Cleaning-100",
        "Non-vehicle Related Insurance": "Insurance-100",
        "Loan Interest (Small business, etc.)": "Loan_Interest-100",
        "Inventory": "Inventory-100",
        "Supplies": "Supplies-100",
        "Home Office Deductions": "Home_Office-100",
        "Depreciation and Section 179": "Depreciation-100",
        "Education and Training": "Courses-100",
        "Other Business Expenses": "Other-100",
        "Charitable Donation": "Donate-100",
        "Custom": "Pin-100"
    ]

    export const transactionImagesDictionary = [
        "Gasoline": "Gas_Txns",
        "Car Maintenance and Repairs": "CarMaintenance_Txns",
        "Car Lease Payments": "CarLease_Txns",
        "Parking Fees and Tolls": "ParkingFees_Txns",
        "In Car Entertainment": "Entertainment_Txns",
        "Car Wash / Cleaning": "CarWash_Txns",
        "Garage Rent": "Garage_Txns",
        "Snacks & Drinks for Clients (50%)": "FoodSnacks_Txns",
        "Other Vehicle Related Expenses": "OtherVehicle_Txns",
        "Car Insurance": "CarInsurance_Txns",
        "Mobile Phone Plan": "Phone_Txns",
        "Electronics (Phone, Laptop, etc.)": "Electronics_Txns",
        "Software": "Software_Txns",
        "Tools": "Tools_Txns",
        "Business Travel": "Travel_Txns",
        "Reimbursement": "Reimbursement_Txns",
        "Office Expenses": "Office_Txns",
        "Advertising and Marketing": "Advertising_Txns",
        "Legal / Professional Services": "Legal_Txns",
        "Professional Dues and Fees": "ProfessionalDues_Txns",
        "Postage, Packaging, and Shipping": "Postage_Txns",
        "Business Gifts (Up to $25)": "BusinessGifts_Txns",
        "Business Meals & Entertainment": "BusinessMeals_Txns",
        "Referral and Commission Fees": "Referral_Txns",
        "Retirement Plan Contributions": "Retirement_Txns",
        "Professional Journal Subscriptions": "JournalSubscriptions_Txns",
        "Real Estate Franchise Fees": "Franchise_Txns",
        "Cleaning": "Cleaning_Txns",
        "Non-vehicle Related Insurance": "Insurance_Txns",
        "Loan Interest (Small business, etc.)": "LoanInterest_Txns",
        "Inventory": "Inventory_Txns",
        "Supplies": "Supplies_Txns",
        "Home Office Deductions": "HomeOffice_Txns",
        "Depreciation and Section 179": "Depreciation_Txns",
        "Education and Training": "Education_Txns",
        "Other Business Expenses": "Other_Txns",
        "Charitable Donation": "Donation_Txns"
    ]



// WEBPACK FOOTER //
// ./src/core/CategoryPicker/categories.js